<!-- <app-header></app-header>
<div class="contact_page" style="background-color: white;overflow: hidden;">
  <div class="contact_image">
    Contact Us
  </div>
  <div class="maps_container" style="padding: 50px 5%;">
    <iframe class="maps"
      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15222.663930439076!2d78.564095!3d17.475694!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b65ecf50bc5%3A0x58b374bf51566908!2sRoku%20Digital!5e0!3m2!1sen!2sin!4v1710153312650!5m2!1sen!2sin"></iframe>
  </div>
  <div class="message_text">Write a Message</div>
  <div class="row placeholder_data">
    <div class="col-md-6 contact_details">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Name</mat-label>
        <input matInput placeholder="Enter Your Name" type="text"
          style="vertical-align: top; margin-left: 5px;">
        <mat-icon matSuffix style="color: var(--primary-color); margin-right: 5px; vertical-align: top;">person</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-6 contact_details">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Enter the Email" type="text"
          style="vertical-align: top; margin-left: 5px;">
        <mat-icon matSuffix style="color: var(--primary-color); margin-right: 5px; vertical-align: top;">email</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-6 contact_details">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Phone Number</mat-label>
        <input matInput placeholder="Phone number" type="text"
          style="vertical-align: top; margin-left: 5px;">
        <mat-icon matSuffix style="color: var(--primary-color); margin-right: 5px; vertical-align: top;">phone</mat-icon>
      </mat-form-field>
    </div>
    <div class="col-md-6 contact_details">
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Subject</mat-label>
        <input matInput placeholder="Subject" type="text"
          style="vertical-align: top; margin-left: 5px;">
        <mat-icon matSuffix style="color: var(--primary-color); margin-right: 5px; vertical-align: top;">book</mat-icon>
      </mat-form-field>
    </div>
    <div class="contact_details">
      <textarea rows="7" appearance="outline" style="width: 100%;padding: 20px;border: 1px solid rgba(128, 128, 128, 0.200);border-radius: 5px;" placeholder="Write a Message"></textarea>
    </div>
    <div style="text-align: center;">
      <button class="contact_submit_button">Send Message<div class="plan_curve"></div> </button>
    </div>
  </div>
</div>
<app-footer></app-footer> -->

<app-header></app-header>
<div class="contact_us">
  <div class="contact_us_header">
    Contact Us
  </div>
  <div class="contact_us_header_description">Any questions or remarks? Just right us a message!</div>
  <div class="conatct_us_data row"style="box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25); padding: 15px;border-radius: 10px;">
    <div class="col-md-5 contact_us_content">
      <div style="color: white;font-size: 20px;font-family: Montserrat;padding: 5% 10px 10px ">Contact Information</div>
      <div style="font-family: Montserrat;font-weight:500;padding-bottom: 10px;padding-left: 10px;">Say something to
        start a live chat !</div>

      <div style="padding-top:10%;">
        <div class="display_icon">
          <mat-icon>call</mat-icon>+91&nbsp;8712228651&nbsp;,+91&nbsp;7075451542
        </div>
        <div class="display_icon">
          <mat-icon>mail</mat-icon>
          <div style="color: white;">
            <a href="mailto:Support@sharkify.ai">Send Support <span>&#64;</span>sharkify.ai</a>
          </div>
        </div>

        <div class="display_icon">
          <mat-icon>location_on</mat-icon>Awfis Oyster complex, Somajiguda,Begumpet
        </div>
        <div class="icon_display">
          <div style="display: flex; gap: 20px; align-items: center;">
            <a href="https://www.linkedin.com/company/sharkify/" target="_blank" style="text-decoration: none;">
              <img src="assets/contact_us/in.png" height="25px" alt="LinkedIn">
            </a>
            <a href="https://www.instagram.com/sharkify.ai?igsh=MW5obm1wdTZ4dW9yOQ==" target="_blank" style="text-decoration: none;">
              <img src="assets/contact_us/insta.png" height="30px" alt="Instagram">
            </a>
            <a href="https://www.facebook.com/share/153Q2sMeGv/?mibextid=wwXIfr" target="_blank" style="text-decoration: none;">
              <img src="assets/contact_us/facebook.png" height="25px" alt="Facebook">
            </a>
            <a routerLink="/Home"  target="_blank" style="text-decoration: none;">
              <img src="assets/contact_us/TW.png" height="25px" alt="Twitter">
            </a>
            <a routerLink="/Home"  target="_blank" style="text-decoration: none;">
              <img src="assets/contact_us/yt.png" height="25px" alt="YouTube">
            </a>
          </div>
        </div>        
      </div>
    </div>

    <div class="col-md-7" style="padding: 3.2% 3% 0%;">
      <div class="contact_us_details row" style="margin-right: 0px;">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="contact_us_fields">
            <mat-label>First Name</mat-label>
            <input matInput type="text" [formControl]="FirstName" style="vertical-align: top; margin-left: 5px;">
            <mat-error *ngIf="FirstName.invalid && FirstName.touched">{{ getFirstNameError() }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="contact_us_fields">
            <mat-label>Last Name</mat-label>
            <input matInput type="text" [formControl]="LastName" style="vertical-align: top; margin-left: 5px;">
            <mat-error *ngIf="LastName.invalid && LastName.touched">{{ getLastNameError() }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="contact_us_fields">
            <mat-label>Email</mat-label>
            <input matInput type="email" [formControl]="Email" style="vertical-align: top; margin-left: 5px;">
            <mat-error *ngIf="Email.invalid && Email.touched">{{ getEmailError() }}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="contact_us_fields">
            <mat-label>Phone Number</mat-label>
            <input matInput type="text" [formControl]="PhoneNumber" style="vertical-align: top; margin-left: 5px;">
            <mat-error *ngIf="PhoneNumber.invalid && PhoneNumber.touched">{{ getMobileNumberError() }}</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-12">
        <mat-form-field appearance="outline" class="contact_us_fields">
          <mat-label>Message</mat-label>
          <textarea matInput [formControl]="Message" rows="5"></textarea>
        </mat-form-field>
      </div>
      <div style="float: right; padding: 3% 0px 0px;">
        <button class="send" (click)="sendEmail()" [disabled]="formInvalid()">Send Message</button>
      </div>

      <div style="display: flex;justify-content: end;width: 100%;padding-right: 4%;">
        <img src="assets/paper.png" alt="flight" height="200px">
      </div>

    </div>
  </div>
  <div class="maps_container" style="padding:5% 0%;">
    <iframe class="maps"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15226.463965380812!2d78.43794489337213!3d17.430206923618687!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91883badb6e3%3A0xfd52a8b8ffbb2567!2sSharkify%20Insurance!5e0!3m2!1sen!2sin!4v1736592647272!5m2!1sen!2sin" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</div>
<app-footer></app-footer>